import axios from "axios";
import { getRequestHeaders } from "./common.service";
import config from "src/config";

const connectService = async (type, payload) => {
    try {
        let response;
        try {
            response = await axios.post( config.SERVER_BASE_URL + '/services/' + type + '/connect', payload, {
                headers: getRequestHeaders()
            });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const generateAuthorizationUrl = async (type, query) => {
    try {
        let response;
        try {
            response = await axios.get( config.SERVER_BASE_URL + '/services/' + type + '/generate_authorization_url', {
                params: query,
                headers: getRequestHeaders()
            });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const getServiceStatus = async (serviceId) => {
    try {
        let response;
        try {
            response = await axios.get( config.SERVER_BASE_URL + '/services/' + serviceId + '/status', {
                headers: getRequestHeaders()
            });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

const syncService = async (serviceId) => {
    try {
        console.log('Syncing service with ID:', serviceId);
        let response;
        try {
            response = await axios.post( config.SERVER_BASE_URL + '/services/' + serviceId + '/sync', {}, {
                headers: getRequestHeaders()
            });
        } catch (error) {
            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

export {
    generateAuthorizationUrl,
    connectService,
    getServiceStatus,
    syncService
}
